import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/project-detail/components/ProjectDetailInteractive.tsx");
